export default {
    modal: {
        active: false
    },
    current: {
        currency: '',
        payment_ref: '',
        client_secret: '',
        payment_type: '',
        to_pay: 0,
        vat: 0,
        total: 0,
        subtotal: 0,
        entity: '',
        gateway: '',
        payload: {},
        description: ''
    },
    clientPayments: [],
    paymentsAppearance: 'list',
    paymentsLoading: false,
    isLoading: false,
    retry: false,
    errorKey: null
}
